<template>
  <b-modal id="FCM"  size="xl"   centered header-bg-variant="primary" header-text-variant="white">
    <template v-slot:modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <b-button size="sm" variant="outline-light" @click="close()">
        關閉視窗
      </b-button>
      <h5></h5>
    </template>
    <h3 class="text-center">結帳確認</h3>
    <h5 class="text-primary">結帳金額</h5>
    <b-table hover :items="items" :fields="fields" small="small" head-variant="light" :outlined="true" stacked="md"  ></b-table>
    <hr>
    <div>
      <h5 class="text-primary">付款資訊</h5>
      <b-row>
        <b-col>
          <p class="font-weight-bold">付款方式</p>
          信用卡付款
        </b-col>
        <b-col>
          <p>發票資訊</p>
          <div>
            聯絡人:{{ orderdata.Name }}<br>連絡信箱:{{ orderdata.Email }}
          </div>
          <p v-if="orderdata.Eintype=='NAMECIRCLE'">
            電子發票 - 儲存在姓名DNA，中獎後寄信通知
          </p>
          <p v-if="orderdata.Eintype=='NATURECODE'">
            電子發票 - 自然人憑證條碼：{{ orderdata.CarruerNum }}
          </p>
          <p v-if="orderdata.Eintype=='DONATION'">
            捐贈發票 - 捐贈碼：{{ orderdata.LoveCode }}
          </p>
          <p v-if="orderdata.Eintype=='PHONECODE'">
            電子發票 -手機條碼：{{ orderdata.CarruerNum }}
          </p>
          <p v-if="orderdata.Eintype=='COMPANYID'">
            統編電子發票：
            <br>統一編號：{{ orderdata.CustomerIdentifier }}
            <br>發票抬頭：{{ orderdata.CustomerName }}
            <br>公司地址：{{ orderdata.CustomerAddr+' '+orderdata.CustomerAddrCode }}
          </p>
        </b-col>
      </b-row>
    </div>
    <template v-slot:modal-footer="{  cancel }">
      <b-button-group >
      <b-button size="lg" variant="outline-primary" @click="cancel()">
        返回修改
      </b-button>
      <b-button size="lg" variant="success" @click="ok()">
        確認付款
      </b-button>
      </b-button-group>
    </template>

  </b-modal>
</template>

<script>
import { toCurrency } from '@/service/commuse'

export default {
  name: 'BillCheckModel',
  props: {
    refs:String,
    orderdata:Object,
    shopcart:Object
  },
  computed:{

  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: '名稱',
          sortable: false,
          colspan:"3"
        },
        {
          key: 'plan',
          label: '購買方案',
          sortable: false
        },
        {
          key: 'price',
          label: '售價',
          sortable: false,
        },
        {
          key: 'payprice',
          label: '實付價格',
          sortable: false,
        }
      ],
      items: [
        { title: this.shopcart.title,
          plan: '會員購點',
          price: 'NT$'+toCurrency(this.shopcart.price) ,
          payprice: 'NT$'+toCurrency(this.shopcart.price) },

      ]
    }
  },
  methods: {
    toggleModal(){
      this.$bvModal.show('FCM')
    },
    ok(){
      this.$bvModal.hide('FCM')
      this.$emit('sendAction');
    }

  }
}
</script>

